import { render, staticRenderFns } from "./CloneEvent.vue?vue&type=template&id=704e1641"
import script from "./CloneEvent.vue?vue&type=script&lang=js"
export * from "./CloneEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports